export default __webpack_public_path__ + "static/media/rustle.49ad3e0c.mp3";